
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the buyer search page by default
    navigate("/backoffice/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-brand-blue mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">Loading DocuNexus</h1>
        <p className="text-gray-600">Please wait...</p>
      </div>
    </div>
  );
};

export default Index;
